import React, { useEffect } from "react"
import { graphql, type PageProps } from "gatsby"
import { getPageData } from "../../helpers/getPageData"
import { type PageData } from "../../interfaces/pageProps"

import Layout from "../../components/Layouts/mainPage"
import { NewHeader } from "../../components/Headers/NewHeader"
import { Banner } from "../../components/Banners/BumazhnyjSamoletik"
import { FourAdvantagesPoints } from "../../components/FourAdvantagesPoints"
import { HowSteps } from "../../components/HowSteps"
import { STEPS_SAMOLETIK } from "../../components/HowSteps/helpers"
import { FormPKW } from "../../components/FormPKW"
import { Partners } from "../../components/PartnersNew"
import { samoletik } from "../../components/PartnersNew/helpers"
import { TwoChoice } from "../../components/twoChoice"
import { GridWithTooltip } from "../../components/GridWithTooltip"
import { NewFooter } from "../../components/NewFooter"

const countDownTime = 1800000

const titleHowToGetCard = <>Как принять участие в акции</>

const titleForm = (
  <>
    Оформите карту сейчас – <br />
    получите подарок!
  </>
)

const subTitlePartners = (
  <>Совершайте покупки с&nbsp;увеличенной рассрочкой в&nbsp;магазинах-партнёрах акции</>
)

const textFirstBlock = (
  <>
    Есть Халва – активируйте акцию!{" "}
    <span>Не&nbsp;упустите возможность получить рассрочку на&nbsp;12&nbsp;месяцев</span>
  </>
)

const textSecondBlock = (
  <>
    Нет Халвы – оформляй карту <br className="d-sm-none" />
    <span>и&nbsp;после получения не&nbsp;забудь зарегистрироваться в&nbsp;акции</span>
  </>
)

export default function Page({ data }: PageProps<PageData>) {
  const { noIndex, ligal } = getPageData(data)

  // Получение первой страницы на которую зашел
  useEffect(() => {
    if (!sessionStorage.getItem("firstURL")) {
      sessionStorage.setItem("firstURL", document.URL)
    }
  }, [])

  return (
    <Layout noHeader noFooter noIndex={noIndex}>
      <NewHeader countDownTime={countDownTime} />
      <Banner orderNum="1" />
      <FourAdvantagesPoints withTitle variant="land" title="Преимущества с Халвой:" orderNum="5" />
      <HowSteps title={titleHowToGetCard} items={STEPS_SAMOLETIK} orderNum="3" />
      <FormPKW
        progressBar
        dataLayerName="shortPersonalForm"
        title={titleForm}
        longTitle
        countDownTime={countDownTime}
        withTimer
        formBtnText="Оформить карту"
        orderNum="4"
        isGreenApprove
      />
      <Partners
        title="Более 260&nbsp;000 магазинов-партнеров"
        subTitle={subTitlePartners}
        additionalPartners={samoletik}
        orderNum="6"
      />
      <TwoChoice
        variant="samoletik"
        textBlockTitle={textFirstBlock}
        secondTextBlockTitle={textSecondBlock}
        orderNum="7"
      />
      <GridWithTooltip orderNum="8" />
      <NewFooter ligal={ligal} orderNum="9" />
    </Layout>
  )
}

export const query = graphql`
  query {
    allDynamicBanner {
      edges {
        node {
          name
          deskGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [1920, 3840]
              )
            }
          }
          mobGatsbyImg {
            url
            childImageSharp {
              gatsbyImageData(
                layout: CONSTRAINED
                quality: 80
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
                breakpoints: [600, 1200]
              )
            }
          }
        }
      }
    }
    admin {
      page(url: "https://halvacard.ru/order/pkw/bumazhnyj-samoletik/") {
        url
        ligal {
          text
        }
        notIndex
      }
    }
  }
`
